import React from "react";
import Container from "@mui/material/Container";
import store from "../store";
import { Provider } from "react-redux";
import PropTypes from "prop-types";
import styles from "./index.module.scss";

export default function Layout({
  hideHomeButton = false,
  children,
  rootStyle = {},
}) {
  return (
    <Provider store={store}>
        <Container
          maxWidth="lg"
          className={styles.container}
          style={rootStyle}
        >
          <div id="main-content" className={styles.main}>{children}</div>
        </Container>
    </Provider>
  );
}

Layout.propTypes = {
  hideHomeButton: PropTypes.bool,
  children: PropTypes.object,
  rootStyle: PropTypes.object,
};
